import { render, staticRenderFns } from "./mechanism.vue?vue&type=template&id=2898bd0a&scoped=true&"
import script from "./mechanism.vue?vue&type=script&lang=js&"
export * from "./mechanism.vue?vue&type=script&lang=js&"
import style0 from "./mechanism.vue?vue&type=style&index=0&id=2898bd0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2898bd0a",
  null
  
)

export default component.exports